<template>
  <div class="submission-cases">
    <div class="submission-cases__pagination" v-if="hasClosedCase">
      <smd-btn clean class="icon-text" @click="back" :disabled="pagesProp.offset === 0 ">
        <i class="smd-icon-arrow-left"/>
        <label dark-normal>Back</label>
      </smd-btn>
      <p>
        {{pagesProp.offset + 1}} of {{pagesProp.count}}
      </p>
      <smd-btn clean class="icon-text" @click="next" :disabled="pagesProp.offset + 1 === pagesProp.count">
        <label dark-normal style="margin-right:10px">Next</label>
        <i class="smd-icon-arrow-right"/>
      </smd-btn>
    </div>
    <div class="pogs-list--panels__header">
      <label>Case No</label>
      <label>Admission Date</label>
      <label>Discharge Date</label>
      <smd-btn pilled-o class="icon-text" @click="toggleSelectAll">
        <label dark>Approve</label>
        <smd-checkbox id="selectAll" :value="selectAll" @click="toggleSelectAll"></smd-checkbox>
      </smd-btn>
    </div>
    <div class="pogs-list--panels compact">
      <div class="pogs-list__item"
           v-for="(c, key) in closedCases"
           :key="key"
           @click="showCaseForm(c._id, c.patientid._id)">

        <div><h3>{{c.caseNum}}</h3></div>
        <div>{{c.admissionDate | formatDate}}</div>
        <div>{{c.dischargeDate | formatDate}}</div>

        <div @click.stop="">
          <smd-checkbox :id="c._id" v-model="selectedCases"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapMutations} from 'vuex'
  import {
    ACTION_LOAD_ALL_CLOSED_CASES,
    ACTION_LOAD_CLOSED_CASES,
    MUTATE_SET_SELECTED_CASES
  } from '../../../../store/modules/submissions'

  import uiHelper from '../../../../mixins/uihelper'
  import Routes from '../../../../router/route-constants'

  export default {
    mixins: [uiHelper],
    props:{
      closedCases: {},
      pagesProp: {}
    },
    data(){
      return{
        selectedCases: {},
        selectAll: 'selectAll'
      }
    },
    computed: {
      hasClosedCase() {
        return !!Object.keys(this.closedCases).length
      }
    },
    methods: {
      ...mapMutations({
        setSelectedCases: MUTATE_SET_SELECTED_CASES
      }),
      ...mapActions({
        loadAllClosedCases: ACTION_LOAD_ALL_CLOSED_CASES
      }),
      next() {
        if (this.pagesProp.offset + 1 !== this.pagesProp.count) {
          this.loadAllClosedCases({offset:this.pagesProp.offset + 1});
        }
      },
      back() {
        if (this.pagesProp.offset !== 0) {
          this.loadAllClosedCases({offset:this.pagesProp.offset-1});
        }
      },
      selectDeselectCases(){
        this.selectedCases = {};
        const cases = Object.assign({}, this.closedCases);
        if(this.selectAll){
          const keys = Object.keys(this.closedCases);
          this.selectedCases = keys.reduce(function (acc, obj) {
            acc[cases[obj]._id] = cases[obj]._id;
            return acc;
          }, {});
        }
      },
      toggleSelectAll(){
        this.selectAll = this.selectAll ? '' : 'selectAll';
        this.selectDeselectCases()
      },
      showCaseForm(caseid, patientid){
        const params = {patientid, caseid};
        this.toggleOverlay();
        this.$router.push({
          name: Routes.ROUTE_EDIT_PATIENT_CASE,
          params: params
        })
      }
    },
    watch: {
      selectedCases(){
        this.setSelectedCases(this.selectedCases);
      }
    },
    mounted(){
      this.selectDeselectCases()
    }
  }
</script>
